<template>
  <div>
    <!-- empty div required for root dialog component -->
    <b-modal ref="modal" size="sm" centered>
      <form ref="form" @submit="submit">
        <fields
          :fields="fields.all()"
          :model="model"
          :errors="errors"
          layout="vertical"
        />
      </form>
    </b-modal>
  </div>
</template>

<script>
import { FormMixin } from 'stylemix-base'
import CompaniesApi from './Api'

export default {
  name: 'CompanyMessage',

  mixins: [FormMixin],

  props: {
    companyId: {
      type: [Number, String],
      required: true,
    },
  },

  data() {
    return {
      model: {
        message: '',
      },
    }
  },

  mounted() {
    const modal = this.$refs.modal

    modal.show()

    modal.$on('shown', () => {
      this.setFields([
        {
          attribute: 'message',
          label: this.$t('companies.message_text'),
          component: 'textarea-field',
        },
      ])
    })

    modal.$on('close', () => {
      this.$close()
    })

    modal.$on('ok', event => {
      event.preventDefault()
      this.submit()
    })

    modal.$on('cancel', () => {
      this.$close()
    })
  },

  methods: {
    submit() {
      return this.$uiBlocker(
        new CompaniesApi()
          .sendMail(this.companyId, this.model)
          .then(result => {
            this.$refs.modal.hide()
            this.$close(this.model)
            this.$toast.success(result.message)
          })
          .catch(error => {
            if (error.status === 422) {
              this.setValidationErrors(error.data.errors)
            }
            return Promise.reject(error)
          }),
        this.$refs.modal.$refs.content,
      )
    },
  },
}
</script>
